import React from 'react';
import { RadioButton } from 'material-ui';
import { equals } from 'ramda';

const AskIfVary = ({
  name,
  enableManualDatesEntry,
  varyBySeason,
  useSeasons,
  selectIfVaryBySeason,
  selectIfUseSeasons,
}) => (
  <div>
    { name === 'allocations' ? <div style={{ paddingLeft: '32px', paddingTop: '16px' }}>Let your partners know how they can book your rooms/products by adding an allocation.</div> : null}
    <div style={{ paddingLeft: '32px', paddingTop: '16px', marginBottom: '8px', color: 'black' }}>Do your {name} vary by season? </div>
    <RadioButton
      checked={equals(varyBySeason, true)}
      label={`Yes, we have different ${name}, depending on the season.`}
      onCheck={() => selectIfVaryBySeason(true)}
      labelStyle={{ color: equals(varyBySeason, true) ? 'black' : 'grey' }}
      style={{ paddingLeft: '32px' }}
    />
    {
      varyBySeason && enableManualDatesEntry ? (
        <div>
          <RadioButton
            label="Use existing seasons"
            checked={equals(useSeasons, true)}
            onCheck={() => selectIfUseSeasons(true)}
            labelStyle={{ color: useSeasons ? 'black' : 'grey' }}
            style={{ paddingLeft: '64px' }}
          />
          <RadioButton
            label={`Enter dates manually`}
            checked={equals(useSeasons, false)}
            onCheck={() => selectIfUseSeasons(false)}
            labelStyle={{ color: equals(useSeasons, false) ? 'black' : 'grey' }}
            style={{ paddingLeft: '64px' }}
          />
        </div>
      ) : <div/>
    }
    <RadioButton
      checked={equals(varyBySeason, false)}
      label={name === 'cancellation policies' ?
        `No, all cancellation policies are the same throughout the year, but vary by room type/product.`
        : `No, all ${name} are the same throughout the year.`}
      onCheck={() => selectIfVaryBySeason(false)}
      labelStyle={{ color: equals(varyBySeason, false) ? 'black' : 'grey' }}
      style={{ paddingLeft: '32px' }}
    />
  </div>
);

export default AskIfVary;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/seasonal-sections/ask-if-vary-by-season.jsx